export default __webpack_public_path__ + "static/media/admin.09d46ed1.png";